import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const LoginRedirect: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    history.push("/");
  }, [history]);

  return null;
};
export default LoginRedirect;